"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMonthSelectorText = void 0;
const getMonthSelectorText = ({ year, month }, texts) => {
    const MONTHS = {
        0: texts.january,
        1: texts.february,
        2: texts.march,
        3: texts.april,
        4: texts.may,
        5: texts.june,
        6: texts.july,
        7: texts.august,
        8: texts.september,
        9: texts.october,
        10: texts.november,
        11: texts.december
    };
    return `${MONTHS[month]} ${year}`;
};
exports.getMonthSelectorText = getMonthSelectorText;
//# sourceMappingURL=getMonthSelectorText.js.map